import React from 'react'
import NextImage from 'next/image'
import NextLink from 'next/link'

import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon'
import { Text } from '@wartek-id/text'

import { getAnchorTarget } from 'utils/link'

interface IEmptyStateProps extends React.HTMLAttributes<HTMLDivElement> {
  imageSrc?: string
  imgWidth?: string
  imgHeight?: string
  title?: string
  description: string
}
export const EmptyState = ({
  imageSrc = '/icon/empty-search-result.png',
  imgWidth = '120px',
  imgHeight = '120px',
  title,
  description,
  ...props
}: IEmptyStateProps) => {
  return (
    <div className="rounded-[4px]" {...props}>
      <div className="mb-6">
        <NextImage
          src={imageSrc}
          alt="illustration"
          width={imgWidth}
          height={imgHeight}
        />
      </div>

      <div className="mb-2">
        <Text variant="heading-md">{title}</Text>
      </div>
      <div>
        <Text variant="body">{description}</Text>
      </div>
    </div>
  )
}

interface IEmptyStateWithActionProps
  extends React.HTMLAttributes<HTMLDivElement> {
  imageSrc?: string
  title?: string
  description: string | React.ReactNode
  actionText?: string
  actionPath?: string
  onActionButtonClicked?: () => void
}
export const EmptyStateWithAction = ({
  imageSrc = '/icon/empty-search-result.png',
  title,
  description,
  actionText,
  actionPath,
  onActionButtonClicked,
  className,
  ...props
}: IEmptyStateWithActionProps) => {
  const actionTarget = getAnchorTarget(actionPath)

  return (
    <div className={className} {...props}>
      <div className="mb-2">
        <NextImage
          src={imageSrc}
          alt="illustration"
          width="64px"
          height="64px"
        />
      </div>

      {Boolean(title) && (
        <div className="mb-2">
          <Text variant="heading-md">{title}</Text>
        </div>
      )}

      <div>
        <Text variant="body">{description}</Text>
      </div>

      {Boolean(actionPath) && (
        <div className="mt-4">
          <NextLink href={actionPath} passHref>
            <Button
              as="a"
              color="black"
              fullWidth={false}
              className="space-x-1"
              target={actionTarget}
              onClick={onActionButtonClicked}
            >
              <span>{actionText}</span>
              <Icon color="inverse" fontSize="small">
                arrow_forward
              </Icon>
            </Button>
          </NextLink>
        </div>
      )}
    </div>
  )
}
